// Logo Carousel: entrance animation for the header section + reduced-motion respect.
document.addEventListener( 'DOMContentLoaded', () => {
	const blocks = Array.from( document.querySelectorAll( '.logo-carousel-block' ) );
	if ( ! blocks.length ) return;

	const EASING   = 'cubic-bezier(0.22, 1, 0.36, 1)';
	const DURATION = 0.65;
	const OFFSET   = '24px';

	// Respect prefers-reduced-motion: pause all tracks immediately.
	const reducedMotion = window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;

	blocks.forEach( ( block ) => {
		const track  = block.querySelector( '.logo-carousel-track' );
		const header = block.querySelector( 'h2, .logo-carousel-block > div' );

		// Reduced-motion: stop the marquee.
		if ( reducedMotion && track ) {
			track.style.animationPlayState = 'paused';
		}

		// Animate the heading / subheadline wrapper in on scroll.
		const headerWrapper = block.querySelector( ':scope > div:first-of-type' );
		if ( headerWrapper ) {
			headerWrapper.style.opacity    = '0';
			headerWrapper.style.transform  = `translateY( ${ OFFSET } )`;
			headerWrapper.style.transition = `opacity ${ DURATION }s ${ EASING }, transform ${ DURATION }s ${ EASING }`;

			const obs = new IntersectionObserver(
				( entries, observer ) => {
					entries.forEach( ( entry ) => {
						if ( ! entry.isIntersecting ) return;
						headerWrapper.style.opacity   = '1';
						headerWrapper.style.transform = 'translateY(0)';
						observer.unobserve( entry.target );
					} );
				},
				{ threshold: 0.25 }
			);
			obs.observe( headerWrapper );
		}

		// Animate the carousel mask in on scroll.
		const mask = block.querySelector( '.logo-carousel-mask' );
		if ( mask ) {
			mask.style.opacity    = '0';
			mask.style.transform  = `translateY( ${ OFFSET } )`;
			mask.style.transition = `opacity ${ DURATION }s ${ EASING } 0.2s, transform ${ DURATION }s ${ EASING } 0.2s`;

			const maskObs = new IntersectionObserver(
				( entries, observer ) => {
					entries.forEach( ( entry ) => {
						if ( ! entry.isIntersecting ) return;
						mask.style.opacity   = '1';
						mask.style.transform = 'translateY(0)';
						observer.unobserve( entry.target );
					} );
				},
				{ threshold: 0.15 }
			);
			maskObs.observe( mask );
		}
	} );

	// Fix seamless looping: ensure track is always wider than the viewport and
	// that the animation distance is pixel-exact (not %-based).
	// Must run after window.load so image dimensions are accurate.
	window.addEventListener( 'load', () => {
		blocks.forEach( ( block ) => {
			const track     = block.querySelector( '.logo-carousel-track' );
			const logoCount = parseInt( block.dataset.logoCount, 10 );

			if ( ! track || ! logoCount || track.children.length < logoCount * 2 ) return;

			// Measure exact scroll distance = left-offset between item 0 and its first clone.
			// This accounts for varying image widths and the flex gap.
			const items      = Array.from( track.children );
			const rect0      = items[ 0 ].getBoundingClientRect();
			const rectClone  = items[ logoCount ].getBoundingClientRect();
			const scrollDist = rectClone.left - rect0.left;

			if ( scrollDist <= 0 ) return;

			// Clone the original set repeatedly until the track fills 2.5× the viewport.
			const origItems = items.slice( 0, logoCount );
			while ( track.scrollWidth < window.innerWidth * 2.5 ) {
				origItems.forEach( ( item ) => track.appendChild( item.cloneNode( true ) ) );
			}

			// Apply the exact pixel scroll distance.
			track.style.setProperty( '--carousel-scroll-dist', `-${ scrollDist }px` );
		} );
	} );
} );
